<template>
    <input type="text" :value="internalString" @input="onChange" />
</template>

<script>
import toNumber from 'lodash/toNumber';
import isNumber from 'lodash/isNumber';
import toInteger from 'lodash/toInteger';

export default {
    props: {
        value: {
            default: null,
        },
        float: {
            default: false,
        },
    },
    data() {
        return {
            internalString: null,
            internalNumber: null,
        };
    },
    methods: {
        onChange(e) {
            this.setInternalValues(e.target.value);
            this.$emit('input', this.internalNumber);
        },
        setInternalValues(newVal) {
            newVal = this.stripString(newVal);
            this.internalNumber = this.parseNumber(newVal);
            this.internalString = this.formatNumber(newVal);
        },
        stripString(x) {
            if (x === null) return null;

            if (this.float) {
                return x.toString().replace(/[^\d.-]/g, '');
            }

            return x.toString().replace(/\D/g, '');
        },
        parseNumber(x) {
            if (x === null) return null;

            return isNumber(toInteger(x)) ? toInteger(x) : null;
        },
        formatNumber(x) {
            if (x === null) return null;

            return isNumber(toNumber(x)) ? toNumber(x).toLocaleString() : null;
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                this.setInternalValues(newVal);
            },
        },
    },
};
</script>
